import RevealPill, { PillChip } from '@/components/Editor/Form/fields/RevealPill';
import styles from './styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
const DEFAULT_SELECTIONS = 'None';

const EditorFormFieldsChartLabels = _ref => {
  let {
    label = 'Labels',
    selections = DEFAULT_SELECTIONS,
    defaultSelections = DEFAULT_SELECTIONS,
    openButtonVariant,
    onEditSelections
  } = _ref;
  const currentSelections = selections || defaultSelections;
  const isModified = selections !== defaultSelections;
  return /*#__PURE__*/_jsx(RevealPill, {
    disableOpen: true,
    label: label,
    activeState: currentSelections ? /*#__PURE__*/_jsx(PillChip, {
      className: styles.chip,
      content: currentSelections
    }) : null,
    variant: isModified ? 'active' : '',
    openButtonVariant: openButtonVariant,
    onOpenChange: () => onEditSelections()
  });
};

export default EditorFormFieldsChartLabels;